module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen4-3c91c0f77f18a7b83a739cd7b8e24581.png";